module.exports = __webpack_public_path__ + "static/media/combat(20).43b42339.PNG";